import { useContext, useEffect, useMemo, useState } from 'react';
import { BranchTypes } from '../../constnats/schemaConstants';
import { TableUpdateContext } from '../../contexts/reviewTypeContext';
import { SchemasContext } from '../../contexts/schemaContext';
import Assert from '../../utils/asserts';
import TableUpdatesRepo from '../../utils/repository/tableUpdatesRepo';
import BranchSettingsProvider from '../branchSettingsProvider';
import { UpdatePhase } from '../financialTables/configuration/constants';
import { RESPONSE_STATUS } from '../../constnats/general';
import Alert from '../../utils/alert';

const TableUpdateContextProvider = ({ currentSchema, children }) => {
    const schemaContext = useContext(SchemasContext);
    const srcSchema = useMemo(() => {
        return schemaContext.find((s) => s.name === currentSchema.name && s.branchType === BranchTypes.MAIN);
    }, [currentSchema, schemaContext]);

    const [reviews, setReviews] = useState([])
    const [updatePhase, setUpdatePhase] = useState(null)
    const [updateId, setUpdateId] = useState(null)
    const [reconciliationEvents, setReconciliationEvents] = useState([])

    useEffect(() => {
        if(currentSchema.branchType === BranchTypes.MAIN) {
            return;
        }

        Assert.trueVal(!!srcSchema, `Could not find Source Schema. Schema Id${currentSchema.id}`)
    
        TableUpdatesRepo.findActive({ srcSchema: srcSchema.id }, (response) => {
            if (response.status === RESPONSE_STATUS.SUCCESS) {
                const update = response.data;
                if (update) {
                    setUpdatePhase(update.phase);
                    setReviews(update.reviews);
                    setUpdateId(update.id);
                    setReconciliationEvents(update.reconciliationEvents);
                }
            } else {
                Alert.error(response.message);
            }
        });
    }, [srcSchema, currentSchema]);

    return (
        <TableUpdateContext.Provider value={{ updatePhase, reviews, updateId, reconciliationEvents }} >
            <BranchSettingsProvider currentSchemaId={currentSchema.id}>
                {children}
            </BranchSettingsProvider>
        </TableUpdateContext.Provider>
    );
};

export default TableUpdateContextProvider;


